export default "/_next/static/chunks/fonts/Montserrat-MediumItalic-latin-dfeb8ca71616523fce78caf26a115dc6.woff2";